import validate from "/builds/rialtic/workflows/console-ui/node_modules/.pnpm/nuxt@3.13.2_@biomejs+biome@1.8.3_@parcel+watcher@2.4.1_@types+node@20.16.11_encoding@0.1.13_e_ncxosminmi73icajmzoj5vjdiq/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45required_45global from "/builds/rialtic/workflows/console-ui/packages/nuxt-auth0/src/runtime/middleware/auth-required.global.ts";
import _02_45rbac_45global from "/builds/rialtic/workflows/console-ui/apps/disputes/middleware/02.rbac.global.ts";
import manifest_45route_45rule from "/builds/rialtic/workflows/console-ui/node_modules/.pnpm/nuxt@3.13.2_@biomejs+biome@1.8.3_@parcel+watcher@2.4.1_@types+node@20.16.11_encoding@0.1.13_e_ncxosminmi73icajmzoj5vjdiq/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45auth_45required_45global,
  _02_45rbac_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "claim-lab": () => import("/builds/rialtic/workflows/console-ui/apps/claim-lab/middleware/claim-lab.ts")
}